import { Uuid } from '../../models/Base';
import { GameJson } from '../../models/GameStore';
import { PostJson } from '../../models/PostStore/Post';
import { AlbumJson } from '../../models/SpaceStore/Album';
import { LeaderboardJson } from '../../models/SpaceStore/Leaderboard';
import { MultiplayerGameJson } from '../../models/SpaceStore/MultiplayerGame';
import { MultiplayerGameSessionJson } from '../../models/SpaceStore/MultiplayerGameSession';
import { SpaceJson } from '../../models/SpaceStore/Space';
import { SpaceMembershipJson } from '../../models/SpaceStore/SpaceMembership';
import { SpaceTeamJson } from '../../models/SpaceStore/SpaceTeam';
import { Optional } from '../../models/Utils';
import { WithProfilesData, WithProfilesParams } from '../utils';

import restClient, { RestResponse } from '.';

interface GetPostData {
  post: PostJson;
  channel: Channel;
  data: ExtraData;
  cheers: null;
}
export interface ExtraData {
  gameSet: AlbumJson;
  classroom: SpaceJson;
  rootId: Uuid;
  userId: Uuid;
  post: PostJson;
  team: SpaceTeamJson;
  leaderboard: LeaderboardJson;
  game: GameJson;
  multiplayerGame: MultiplayerGameJson;
  multiplayerGameSession: MultiplayerGameSessionJson;
  imageUrls: Record<string, string>; // Add imageUrls mapping
  channel: Channel;
}
interface Channel {
  classroom: SpaceJson;
  membership: SpaceMembershipJson | null;
  rootId: string;
}

export const getPost = <P extends Optional<WithProfilesParams>>(
  path: { postId: Uuid },
  params: P = {} as P,
): Promise<RestResponse<GetPostData & WithProfilesData<P>>> => {
  return restClient.get(`/posts/${path.postId}`, params);
};
